export default {
    small: '@media (maxHeight: 670px)',
    normal: '@media (minHeight: 670px)',
    double: '@media (minWidth: 975px)',
};
